import React, { useState, useEffect } from "react";
import AlbumGallery from "./album_gallery";
import GalleryNews from "./gallery_news";
import Updates from "./updates";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import VideoGallery from "./video_gallery"
import { useDispatch, useSelector } from "react-redux";
import { fetchCQAData } from "../../redux/slicer/gallerySlice";
import parse from "html-react-parser";
import Preloader from "../../assets/sab.jpeg";
import { FaLink, FaArrowUp } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRef } from "react";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
function GalleryAndNews() {
  const sliderRef = useRef(null);
  const dispatch = useDispatch();
  const {
    data: CQAData,
    loading: CQALoading,
    error: CQAError,
  } = useSelector((state) => state.gallery.CQA);

  useEffect(() => {
    dispatch(fetchCQAData());
  }, [dispatch]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [showFullText, setShowFullText] = useState(false);

  // if (CQALoading) {
  //   return <div>Loading...</div>;
  // }

  // if (CQAError) {
  //   return <div>Error: {CQAError}</div>;
  // }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Default for xl & 2xl
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280, // lg screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024, // md screens
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // sm screens
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  if (CQALoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (CQAError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">Error: {CQAError}</p>
      </div>
    );
  }
  return (
    <div>
      {/* Hero Section */}
      <div className="relative w-full">
        <div className="w-full  h-[400px]">
          <img
            src={"https://www.capital.edu/media/ycxbjsga/student-show.jpg"}
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold  font-titillium">
              Gallery & News
            </h2>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="mt-6 py-6 px-4 md:px-20" id="gallery">
        <h2 className="text-primary-color text-3xl sm:text-4xl mb-4 font-titillium">
          Gallery
        </h2>

        <AlbumGallery />
        <div className="py-6 mt-6" id="video">
          <h2 className="text-primary-color text-3xl sm:text-4xl ml-5  font-titillium">
            Video Gallery
          </h2>
          <div className="mt-4">
            <VideoGallery />
          </div>
        </div>
        {/* News Section */}
        <div className="py-6 mt-6" id="news">
          <h2 className="text-primary-color text-3xl sm:text-4xl ml-5 text-left font-titillium">
            News
          </h2>
          <div className="mt-4">
            <GalleryNews />
          </div>
        </div>
      </div>

      {/* Center for Quality Assurance */}


      {/* <div className="px-6 pt-4 pb-2 flex justify-end">
        <button
          onClick={scrollToTop}
          className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-2xl"
        >
          <FaArrowUp />
        </button>
      </div> */}
    </div>
  );
}

export default GalleryAndNews;
